import angular from "angular";

export const vsName = "focusFirstInput";

export const focusFirstInputDirective = [
  "$timeout",
  function ($timeout: angular.ITimeoutService): angular.IDirective {
    return {
      restrict: "A",
      link: {
        post: (scope, instanceElement) => {
          $timeout(0).then(() => {
            const inputQuery = instanceElement.find("input");
            if (inputQuery.length === 0) {
              return;
            }
            const input = <HTMLInputElement>inputQuery[0];
            input.select();
            input.focus();
          });
        },
      },
      scope: false,
    };
  },
];
